import { useParams, useLocation } from "react-router-dom";
import CourseInternalComponent from "../courseInternal/CourseInternalComponent";
import CourseExternalComponent from "../courseExternal/CourseExternalComponent";
import { GetCoursesServices } from "../../services/getCourses/GetCoursesServices";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { CourseContentProvider } from "../../context/CourseContentContext";
import LoadingComponent from "../loading/LoadingComponent";

const CourseRouterComponent = () => {
  const { nameCourse } = useParams();
  const location = useLocation();
  const { token } = useAuth();
  const [course, setCourse] = useState(location.state?.course || null);

  useEffect(() => {
    if (!course) {
      const fetchCourses = async () => {
        try {
          const response = await GetCoursesServices(token);
          if (!response.error) {
            const foundCourse = response.data.find((c) => {
              console.log("Comparación:", c.url_front, nameCourse);
              return c.url_front === `/${nameCourse}/`;
            });
  
            setCourse(foundCourse || null);
          }
        } catch (error) {
          console.error("Error al obtener cursos:", error);
          setCourse(null);
        }
      };
      fetchCourses();
    }
  }, [nameCourse, token, course]);
  
  if (!course) {
    return <LoadingComponent text={'redirigiendo'} />;
  }

  console.log("REDIRECCION DE LOS URL: ", course)

  return course.is_type_task ? (
    <CourseContentProvider>
      <CourseInternalComponent course={course} />
    </CourseContentProvider>
  ) : (
    <CourseExternalComponent course={course} />
  );
};

export default CourseRouterComponent;
